import React from "react";
import { Typography, Box, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import SpecificPersonalInfoXs from "./small-ui/SpecificPersonalInfoXs";

const SpecificPersonalInfo = ({ id, isXs }) => {
  const { t } = useTranslation();
  if (isXs) return <SpecificPersonalInfoXs id={id} />;

  return (
    <Paper elevation={1} sx={{ p: 4, mb: 4 }} id={id}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <i className="fas fa-id-card fa-2x" style={{ color: "#0c4d96" }}></i>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ ml: 2, color: "#0c4d96" }}
        >
          {t("privacy-policy.specific-personal-info.title")}
        </Typography>
      </Box>

      <Typography paragraph>
        {t("privacy-policy.specific-personal-info.intro")}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.specific-personal-info.company.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.specific-personal-info.company.name")}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.specific-personal-info.compliance.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.specific-personal-info.compliance.text")}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.specific-personal-info.security.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.specific-personal-info.security.text")}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.specific-personal-info.inquiries.title")}
      </Typography>
      <Box sx={{ mb: 3 }}>
        <Typography>
          {t("privacy-policy.specific-personal-info.inquiries.department")}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <i className="fas fa-phone"></i>
          <Typography sx={{ ml: 1 }}>
            {t("privacy-policy.specific-personal-info.inquiries.phone")}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <i className="fas fa-envelope"></i>
          <Typography sx={{ ml: 1 }}>
            {t("privacy-policy.specific-personal-info.inquiries.email")}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 3, mb: 4 }}>
        <Typography>
          {t("privacy-policy.specific-personal-info.footer.dates")}
        </Typography>
        <Typography>
          {t("privacy-policy.specific-personal-info.footer.company")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default SpecificPersonalInfo;
